import { gql } from "@apollo/client";

export const CREATE_COMMENT = gql`
  mutation createComment($input: CommentInput!) {
    makeComment(input: $input) {
      _id
      resourceId
      resourceType
      parentId
      # author{
      #   _id
      #   role
      #   firstName
      # }
      comment
      # replies{
      #   _id
      #   resourceId
      #   resourceType
      #   parentId
      #   comment
      # }
    }
  }
`;
